import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import css from './WaitingRoomHistory.css';
import Breadcrumbs from './Breadcrumbs';
import StickyFooterLayout from 'common/StickyFooterLayout';
import HistoryHeader from './HistoryHeader';
import HistoryTable from './HistoryTable';
import HistoryFooter from './HistoryFooter';
import NoMeetings from './NoMeetings';
import useStarfishAPI from "../hooks/useStarfishAPI";
import useError from "../hooks/useError";
import { isEmpty } from 'lodash';

function WaitingRoomHistory(props) {
  const [appointments, setAppointments] = useState([]);
  const [{data, success, error}, callAPI] = useStarfishAPI();
  
  const getAppointmentsHistory = () => {
    const URL = `../serviceCatalog/getWaitingRoomDailyHistory.html`;
    callAPI(URL, { method: 'GET' });
  };

  // Fetch appointments history only on mount
  useEffect(() => {
    getAppointmentsHistory();
  }, []);

  useEffect(() => {
    if ( success ) setAppointments(data.waitingRoomHistory);
  }, [success]);

  // Add error listener
  useError(error, props.setError);

  const getContent = () => {
    if ( !isEmpty(data) && data.waitingRoomHistory.length === 0 ) return <NoMeetings />;
    if ( appointments.length === 0 ) return null;
    return (
      <>
        <HistoryHeader formatDate={props.formatDate} /> 
        <HistoryTable
          appointments={appointments}
          openStudentFolder={props.openStudentFolder}
          editAppointment={props.editAppointment}
          handleGroupSession={props.handleGroupSession}
          getAppointmentsHistory={getAppointmentsHistory}
          formatDate={props.formatDate}
          setError={props.setError}
        />
      </>   
    );
  };

  const getFooter = () => {
    return appointments.length > 0
      ? <HistoryFooter totalMeetings={data.waitingRoomHistory.length} />
      : null;
  };

  return (
    <StickyFooterLayout
      content={(
        <div className={css['container']}>
          <Breadcrumbs />
          {getContent()}
        </div>
      )}
      footer={getFooter()}
    />
  );
}

WaitingRoomHistory.propTypes = {  
  openStudentFolder: PropTypes.func.isRequired,
  editAppointment: PropTypes.func.isRequired,
  handleGroupSession: PropTypes.func.isRequired,
  formatDate: PropTypes.func.isRequired,
  setError: PropTypes.func.isRequired,
};

export default WaitingRoomHistory;
